import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { APIS } from 'src/app/apis';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
 isLogin: boolean = false;
  errorMessage: any;
  registerUrl = `${APIS.auth}/register`;

  constructor(private router:Router, private http: HttpClient) { }

  ngOnInit(): void {
    this.isUserLogin();
  }

  async onSubmit(form: NgForm) {
    // console.log('Your form data : ', form.value);
    // const url = `${this.registerUrl}`;
    // console.log(`calling ${url}`);
    // let res = await this.http.post<any>(url, form.value).subscribe
    //   (
    //     res => {
    //       if (res.status) {
    //           console.log(res);
    //           this.auth.setDataInLocalStorage('userData', JSON.stringify(res.data));
    //           this.auth.setDataInLocalStorage('token', res.token);
    //           this.router.navigate(['login']);} 
    //       else {
    //         console.log(res);
    //         alert(res.msg);
    //       }

    //     },
    //     err => { this.errorMessage = err['error'].message; }
    //   );
  }

  isUserLogin() {
    // console.log(this.auth.getUserDetails());
    // if (this.auth.getUserDetails() != null) {
    //   this.isLogin = true;
    // }

  }

}
